import { useDisclosure, useHeadroom, useIsomorphicEffect, useViewportSize } from '@mantine/hooks';
import { type FC, type PropsWithChildren, useMemo, useState } from 'react';
import { usePageContext } from 'vike-react/usePageContext';
import type { LandingType } from '#website/helpers.tsx';
import { LandingContext } from '#website/layouts/Landing.context';

export const LandingProvider: FC<PropsWithChildren> = ({ children }) => {
	const pageContext = usePageContext();
	const [isFloatingHeaderPinnedDisabled, setIsFloatingHeaderPinnedDisabled] = useState(false);
	const { width } = useViewportSize();
	const [columnWidth, setColumnWidth] = useState(width > 960 ? 920 : width - width * 0.06);

	const isVet = pageContext.urlPathname === '/veterinarias';
	const isMedical = pageContext.urlPathname === '/consultorios-medicos';

	let landingSource: LandingType = 'website';
	if (isVet) {
		landingSource = 'website-vet';
	} else if (isMedical) {
		landingSource = 'website-medic';
	}
	const headerPinned = useHeadroom({ fixedAt: 120 });

	useIsomorphicEffect(() => {
		setColumnWidth(width > 960 ? 920 : width - width * 0.06);
	}, [width]);
	const [menuOpened, { toggle: toggleMenu, close: closeMenu }] = useDisclosure(false);

	const value = useMemo(
		() => ({
			columnWidth,
			menuOpened,
			toggleMenu,
			closeMenu,
			isFloatingHeaderPinnedDisabled,
			setIsFloatingHeaderPinnedDisabled,
			headerPinned,
			isMedical,
			isVet,
			landingSource,
		}),
		[columnWidth, menuOpened, toggleMenu, closeMenu, isFloatingHeaderPinnedDisabled, headerPinned, isMedical, isVet, landingSource],
	);

	return <LandingContext.Provider value={value}>{children}</LandingContext.Provider>;
};
